import {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {DeviceType} from '../incase-domain/common/DeviceType.enum';
import {setSelectedDeviceTypeAction} from '../store/actions/layout.actions';
import {desktopViewSelector, fullscreenSelector, selectedDeviceTypeSelector} from '../store/selectors/layout.selectors';

const MINIMIZED_LAYOUT_CLASS = 'is_minimized';

export function useLayout(): {mobileView: boolean; tabletScreenSize: boolean; mobileScreenSize: boolean} {
    const dispatch = useDispatch();

    const [isMobileScreensize, setIsMobileScreensize] = useState(false);
    const [isTabletScreensize, setIsTabletScreensize] = useState(false);

    const isDesktopViewSelected = useSelector(desktopViewSelector);
    const isFullscreen = useSelector(fullscreenSelector);
    const deviceTypeActive = useSelector(selectedDeviceTypeSelector);

    const showMobileView = useMemo(() => isMobileScreensize && !isDesktopViewSelected, [isMobileScreensize, isDesktopViewSelected]);
    const hideSidebar = useMemo(() => showMobileView || isFullscreen, [showMobileView, isFullscreen]);

    useEffect(() => {
        const deviceType = showMobileView ? DeviceType.MOBILE : DeviceType.DESKTOP;
        if (deviceType !== deviceTypeActive) {
            dispatch(setSelectedDeviceTypeAction(deviceType));
        }
    }, [deviceTypeActive, dispatch, showMobileView]);

    useEffect(() => {
        if (hideSidebar) {
            document.querySelector('.l-base')?.classList.add(MINIMIZED_LAYOUT_CLASS);
        } else {
            document.querySelector('.l-base')?.classList.remove(MINIMIZED_LAYOUT_CLASS);
        }
        return () => {
            document.querySelector('.l-base')?.classList.remove(MINIMIZED_LAYOUT_CLASS);
        };
    }, [hideSidebar]);

    useEffect(() => {
        const checkWindowWidth = (): void => {
            const isMobile = window.innerWidth < 767;
            setIsMobileScreensize(isMobile);

            const isTablet = !isMobile && window.innerWidth < 1160;
            setIsTabletScreensize(isTablet);
        };

        checkWindowWidth();
        window.addEventListener('resize', checkWindowWidth);

        return () => {
            window.removeEventListener('resize', checkWindowWidth);
        };
    }, [dispatch]);

    return {mobileView: showMobileView, tabletScreenSize: isTabletScreensize, mobileScreenSize: isMobileScreensize};
}
